import React from 'react';
var ModalContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide: function onHide() {}
});
export default ModalContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/ModalContext.js
// module id = 651
// module chunks = 11